export default (input) => {
    // Show custom validation alerts for all fields at once.
    const formField = input.closest('.field');

    if (formField) {
        input.addEventListener('invalid', (event) => {
            event.preventDefault();
            if (!formField.classList.contains('validation-error')) {
                formField.setAttribute('validation', input.validationMessage);
                formField.classList.add('validation-error');
                setTimeout(() => formField.classList.remove('validation-error'), 7500);
            }
        });
        input.addEventListener('focus', () => {
            formField.classList.remove('validation-error');
        });
        input.addEventListener('change', () => {
            formField.classList.remove('validation-error');
        });
    }
};
